import * as yup from 'yup';

export const CITY = 'city';
export const BOOKING_ID = 'bookingId';
export const MOVE_IN_DATE = 'moveInDate';
export const NAME = 'name';
export const EMAIL = 'email';
export const COMMENT = 'comment';
export const LANDLORD_TYPE = 'landlordType';
export const RENTABLE_UNIT_ID = 'rentableUnitId';

export const FIELD_IDS = [
  CITY,
  BOOKING_ID,
  MOVE_IN_DATE,
  NAME,
  EMAIL,
  COMMENT,
  LANDLORD_TYPE,
  RENTABLE_UNIT_ID
];

export const CITY_DROPDOWN_OPTIONS = [
  { value: 'barcelona', text: 'Barcelona' },
  { value: 'berlin', text: 'Berlin' },
  { value: 'brussels', text: 'Brussels' },
  { value: 'dublin', text: 'Dublin' },
  { value: 'lisbon', text: 'Lisbon' },
  { value: 'london', text: 'London' },
  { value: 'madrid', text: 'Madrid' },
  { value: 'milan', text: 'Milan' },
  { value: 'paris', text: 'Paris' },
  { value: 'rome', text: 'Rome' },
  { value: 'valencia', text: 'Valencia' }
];

export const FORM_FIELDS = {
  [CITY]: {
    type: 'select',
    props: {
      required: true,
      options: CITY_DROPDOWN_OPTIONS
    },
    schema: yup.string().ensure().required('contact-us.required-field')
  },
  [BOOKING_ID]: {
    type: 'text',
    props: {
      required: true
    },
    schema: yup.string().ensure().required('contact-us.required-field')
  },
  [MOVE_IN_DATE]: {
    type: 'date',
    props: {
      required: true
    },
    schema: yup.string().ensure().required('contact-us.required-field')
  },
  [NAME]: {
    type: 'text',
    props: {
      required: true
    },
    schema: yup.string().ensure().required('contact-us.required-field')
  },
  [EMAIL]: {
    type: 'email',
    props: {
      required: true
    },
    schema: yup
      .string()
      .email('contact-us.required-field')
      .ensure()
      .required('contact-us.required-field')
  },
  [COMMENT]: {
    type: 'textarea',
    props: {
      required: true
    },
    schema: yup.string().ensure().required('contact-us.required-field')
  },
  [RENTABLE_UNIT_ID]: {
    type: 'text',
    props: {
      required: true
    },
    schema: yup.string().ensure().required('contact-us.required-field')
  },
  [LANDLORD_TYPE]: {
    type: 'select',
    props: {
      options: [
        { text: 'Particular', value: 'b2b' },
        { text: 'Company', value: 'b2c' }
      ]
    },
    schema: yup.string().ensure().required('contact-us.required-field')
  }
};
